import V1PageMFCExt from "./v1_mfc_ext"
class V1PageMFCText extends V1PageMFCExt {
  constructor(props) {
    super(props)
    this.state = {}
  }
  getMyControl = () => {
    return this.props.typeControl || "text"
  }
  componentDidMount() {}
  getMyType = () => {
    return `v1_mfc_${this.getMyControl()}`
  }
}

export default V1PageMFCText
